/** @format */

import {useCallback, useState} from 'react';
import {ORDER_STANDARD_PROCESSING} from 'frontier-constants';
import SuperAgent from 'superagent';
import {useForm} from 'frontier-form';

function useDesignReorder(designId) {
    const [isShowingForm, setIsShowingForm] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [isInCart, setIsInCart] = useState(false);
    const resetFormData = {
        qty: '',
        processing_id: ORDER_STANDARD_PROCESSING,
        proof_type_id: '',
        substrate_id: '',
        laminate_id: '',
        color_id: ''
    };

    const {formData, setFormData, ...formFunctions} = useForm({...resetFormData});

    const handleReorderCancel = useCallback(() => {
        setIsShowingForm(false);
        setIsReorderConfirm(false);
        setIsInCart(false);
        setFormData({...resetFormData});
    }, []);

    const handleReorderSave = useCallback(() => {
        setIsSaving(true);
        SuperAgent.post('/carts/reorder-design')
            .set('accept', 'application/json')
            .send({
                id: designId,
                ...formData
            })
            .end((err, response) => {
                setIsInCart(true);
                setIsSaving(false);
            });
    }, [designId, formData]);

    const handleChange = useCallback(updateTarget => {
        setFormData(prevFormData => ({
            ...prevFormData,
            ...updateTarget
        }));
    }, []);

    return {
        isShowingReorderForm: isShowingForm,
        isReorderSaving: isSaving,
        isReorderInCart: isInCart,
        reorderFormData: formData,
        toggleIsShowingReorderForm: useCallback(() => {
            const nextIsShowingReorderForm = !isShowingForm;
            setIsSaving(false);
            if (nextIsShowingReorderForm) {
                setIsShowingForm(nextIsShowingReorderForm);
            } else {
                setIsShowingForm(nextIsShowingReorderForm);
                setFormData({...resetFormData});
            }
        }, [isShowingForm]),
        handleReorderAddMore: useCallback(() => {
            setIsShowingForm(true);
            setIsSaving(false);
            setIsInCart(false);
        }, []),
        handleReorderSave,
        handleChange,
        ...formFunctions
    };
}

export default useDesignReorder;
